var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { ethers } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { FaArrowLeft } from 'react-icons/fa';
import { getyVaults } from '../constants';
export var Withdraw = createPlugin({
    protocol: 'YEARN',
    type: 'ACTION',
    method: 'withdraw',
    description: 'Withdraw from a Yearn vault',
    getParams: function (_a) {
        var chainId = _a.chainId, vaultAddress = _a.vaultAddress;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'yearn_vault',
                    options: getyVaults({ chainId: chainId }),
                    isPreview: true,
                    icon: FaArrowLeft
                }),
                receiveToken: new FctAddress({
                    destination: 'erc20',
                    readonly: true,
                }),
                methodParams: {
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                    recipient: new FctAddress({ value: vaultAddress, isPreview: true }),
                },
            },
            output: {
                amount: new FctValue({ destination: 'wei_amount', isPreview: true })
            },
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var _this = this;
        var input = _a.input, chainId = _a.chainId, provider = _a.provider;
        var to = input.to, receiveToken = input.receiveToken;
        var vaults = getyVaults({ chainId: chainId });
        var getParamsAsync = function () { return __awaiter(_this, void 0, void 0, function () {
            var toValue, asset, tokenContract, symbol, decimals;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        toValue = to.value;
                        if (!toValue)
                            return [2 /*return*/, {
                                    params: { receiveToken: undefined },
                                    error: undefined,
                                }];
                        if (typeof toValue !== 'string')
                            return [2 /*return*/, {
                                    params: { receiveToken: undefined },
                                    error: undefined,
                                }];
                        asset = vaults.find(function (v) { return v.value.toLowerCase() === toValue.toLowerCase(); });
                        if (!asset)
                            return [2 /*return*/, {
                                    params: { receiveToken: undefined },
                                    error: undefined,
                                }];
                        if (!asset.underlyingToken)
                            return [2 /*return*/, {
                                    params: { receiveToken: undefined },
                                    error: undefined,
                                }];
                        tokenContract = new ethers.Contract(asset.underlyingToken, ['function decimals() view returns (uint8 decimals)', 'function symbol() view returns (string symbol)'], provider);
                        return [4 /*yield*/, tokenContract.symbol()];
                    case 1:
                        symbol = _a.sent();
                        return [4 /*yield*/, tokenContract.decimals()];
                    case 2:
                        decimals = _a.sent();
                        receiveToken.value = asset.underlyingToken;
                        receiveToken.label = symbol;
                        receiveToken.decimals = decimals;
                        return [2 /*return*/, {
                                params: { receiveToken: asset.underlyingToken },
                                error: undefined,
                            }];
                }
            });
        }); };
        return { get: getParamsAsync, depParamKeys: ['to'] };
    },
});
